import type { FC, SVGProps } from 'react';

/**
 * Outlined warning triangle used as the category glyph on AI Insight cards
 * (Figma node 248:20021). Distinct from `warning-triangle`, which is the solid
 * 16x16 variant used elsewhere — this one is outlined and 20.08 x 19.
 *
 * Fills are `currentColor` so the card can tint it per category.
 */
export const InsightWarningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    fill="none"
    height="19"
    width="20.0802"
    viewBox="0 0 20.0802 19"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.6858 14.0502L13.1005 1.80664C12.5012 0.692257 11.3284 0 10.04 0C8.75158 0 7.5789 0.692257 6.97945 1.80664L0.394214 14.0502C-0.165608 15.091 -0.126784 16.3626 0.495396 17.3684C1.11744 18.3748 2.25144 19 3.45476 19H16.6254C17.8285 19 18.9625 18.3748 19.5846 17.3687C20.2068 16.3626 20.2456 15.091 19.6858 14.0502ZM17.8628 16.3522C17.6026 16.7731 17.1284 17.0345 16.6253 17.0345H3.45469C2.95147 17.0345 2.47734 16.7731 2.21711 16.352C1.95694 15.9315 1.94078 15.3998 2.17486 14.9646L8.76016 2.72094C9.01074 2.25498 9.50123 1.96546 10.04 1.96546C10.5788 1.96546 11.0693 2.25491 11.3198 2.72094L17.9051 14.9646C18.1392 15.3998 18.123 15.9315 17.8628 16.3522Z"
    />
    <path
      fill="currentColor"
      d="M9.65409 12.89H10.4164L11.1602 5.41H8.9102L9.65409 12.89Z"
    />
    <path
      fill="currentColor"
      d="M10.0402 13.58C9.43789 13.58 8.9502 14.0566 8.9502 14.645C8.9502 15.2329 9.43789 15.71 10.0402 15.71C10.6424 15.71 11.1302 15.2329 11.1302 14.645C11.1302 14.0566 10.6425 13.58 10.0402 13.58Z"
    />
  </svg>
);
